import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';
import Colors from '../../layout/theme/utils/colors';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    container: {
      visibility: 'hidden',
    },
    details: {
      overflowY: 'auto',
      maxHeight: '50vw',
    },
    changeContainer: {
      borderBottom: '1px solid ' + Colors.hint_gray,
      padding: 16,
      background: Colors.white,
    },
    auditValue: {
      color: Colors.almost_black,
      fontWeight: 500,
      wordBreak: 'break-word',
      fontSize: '14px',
      fontFamily: 'Sora',
    },
    noPaddingMargin: {
      margin: '0px',
      padding: '0px',
    },
    auditListItem: {
      margin: '0px',
      padding: '0px',
      marginBottom: '15px',
    },
    auditKey: {
      fontSize: '12px',
      fontFamily: 'Sora',
      color: Colors.font_gray,
    },
    owner: {
      color: theme.palette.text.primary,
      fontWeight: 500,
    },
    dateContainer: {
      marginBottom: theme.spacing(2),
      // color: theme.palette.text.hint,
    },
  }),
);
